import React from 'react';
import imgAbout from "../../assets/images/about.jpg"

const AboutSection = () => {
    return (
        <div className="container-fluid pt-6 pb-6">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                        <div className="about-img">
                            <img className="img-fluid w-100" src={imgAbout} alt="Mafra Tintas" />
                        </div>
                    </div>
                    <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                        <h1 className="display-6 text-uppercase mb-4">Mafra Tintas - Qualidade em Cores para Sua Vida</h1>
                        <p className="mb-4">
                            A Mafra Tintas é especializada em soluções completas em tintas residenciais, automotivas e industriais.
                            Com uma equipe de especialistas prontos para atender, oferecemos produtos das melhores marcas e suporte técnico personalizado para cada projeto.
                        </p>
                        <div className="row g-5 mb-4">
                            <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 btn-xl-square bg-light me-3">
                                        <i className="fa fa-paint-roller fa-2x text-primary"></i>
                                    </div>
                                    <h5 className="lh-base text-uppercase mb-0">Variedade de Tintas e Cores</h5>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 btn-xl-square bg-light me-3">
                                        <i className="fa fa-handshake fa-2x text-primary"></i>
                                    </div>
                                    <h5 className="lh-base text-uppercase mb-0">Atendimento Personalizado</h5>
                                </div>
                            </div>
                        </div>
                        <p><i className="fa fa-check-square text-primary me-3"></i>Produtos de alta qualidade e durabilidade</p>
                        <p><i className="fa fa-check-square text-primary me-3"></i>Consultoria especializada para cada tipo de projeto</p>
                        <p><i className="fa fa-check-square text-primary me-3"></i>Entrega rápida e eficiente em toda a região</p>
                        <div className="border border-5 border-primary p-4 text-center mt-4">
                            <h4 className="lh-base text-uppercase mb-0">Mafra Tintas - Sua Cor, Nosso Compromisso!</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutSection;
